import Spacing from 'components/Spacing';
import { FieldRow } from 'components/FormElements';
import { FirmSelector } from 'components/FirmSelector';

type Props = {
  filters: { firmId?: string };
  handleChangeFilters: (filters: { firmId?: string }) => void;
};

const FilterPanel: React.FC<Props> = ({ filters, handleChangeFilters }) => {
  return (
    <Spacing>
      <FieldRow title="Firm" fullWidth>
        <FirmSelector
          firmId={filters.firmId}
          placeholder="Search by firm"
          onChange={(firmId) => {
            handleChangeFilters({ firmId });
          }}
        />
      </FieldRow>
    </Spacing>
  );
};

export default FilterPanel;
